import { GenericModel } from "../../generic.model";
import { HostModel } from "../common/host.model";
import { makeModel } from "../../../service/utils/utils.service";


export class ProductModel extends GenericModel {
    public host: HostModel;
    public serviceArray: Array<{ xRef: string }>;
    public vehicleArray: Array<{ xRef: string }>;
    public vehicleRentalArray: Array<{ xRef: string }>;
    public xId: string;
    public xIsArray: string[];


    protected fromJson(json?: any): boolean {
        this.host = makeModel(json.host, HostModel);
        this.serviceArray = json.serviceArray ?? null;
        this.vehicleArray = json.vehicleArray ?? null;
        this.vehicleRentalArray = json.vehicleRentalArray ?? null;
        this.xId = json.xId ?? null;
        this.xIsArray = json.xIsArray ?? null;
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xId !== null;
    }
}